const baseStyle = {
  maxW: "container.lg",
  py: [6, 8, 12, 16, 20],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  baseStyle,
};
